var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-message-box",class:( _obj = {}, _obj['chat-message-box_red'] = _vm.theme === 'red', _obj['chat-message-box_gray'] = _vm.theme === 'gray', _obj )},[_c('p',{staticClass:"chat-message-box__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }